import { useState } from "react";
import styles from "./CustomFieldForms.module.css";
import DropdownSelect from "../inputs/DropdownSelect";
import Toggle from "../selectors/Toggle";

const FIELD_TYPE_OPTIONS = [
  { value: "text",    label: "Texto" },
  { value: "number",  label: "Número" },
  { value: "date",    label: "Fecha" },
  { value: "boolean", label: "Booleano" },
];

export function AddCustomFieldDefForm({ onAdd, onCancel, saving = false }) {
  const [name, setName] = useState("");
  const [type, setType] = useState("text");

  const handleAdd = () => {
    if (!name.trim()) return;
    onAdd?.(name.trim(), type);
    setName("");
    setType("text");
  };

  return (
    <div className={styles.form}>
      <div className={styles.row}>
        <input
          className={styles.input}
          placeholder="Nombre"
          value={name}
          onChange={(e) => setName(e.target.value)}
          autoFocus
          onKeyDown={(e) => { if (e.key === "Enter") handleAdd(); }}
        />
        <div className={styles.dropdownWrap}>
          <DropdownSelect
            placeholder="Tipo de dato"
            options={FIELD_TYPE_OPTIONS}
            value={type}
            onChange={(v) => setType(v)}
          />
        </div>
      </div>
      <div className={styles.actions}>
        <button
          type="button"
          className={styles.saveBtn}
          onClick={handleAdd}
          disabled={saving || !name.trim()}
        >
          {saving ? "Agregando..." : "Agregar"}
        </button>
        <button type="button" className={styles.cancelBtn} onClick={onCancel}>
          Cancelar
        </button>
      </div>
    </div>
  );
}

export function AddCustomFieldValueForm({
  fields = [],
  onAdd,
  onCancel,
  saving = false,
  menuPlacement = "top",
}) {
  const [selectedId, setSelectedId] = useState("");
  const [textValue, setTextValue] = useState("");
  const [boolValue, setBoolValue] = useState(false);

  const fieldOptions = fields.map((f) => ({ value: String(f.id), label: f.name }));
  const selectedField = fields.find((f) => String(f.id) === selectedId);
  const dataType = selectedField?.data_type ?? "text";

  const handleFieldChange = (v) => {
    setSelectedId(v);
    setTextValue("");
    setBoolValue(false);
  };

  const handleAdd = () => {
    if (!selectedId) return;
    const finalValue = dataType === "boolean" ? boolValue : textValue;
    onAdd?.(selectedId, finalValue);
  };

  return (
    <div className={styles.form}>
      <div className={styles.row}>
        <div className={styles.dropdownWrap}>
          <DropdownSelect
            placeholder="Seleccionar dato..."
            options={fieldOptions}
            value={selectedId}
            onChange={handleFieldChange}
            menuPlacement={menuPlacement}
          />
        </div>
        {selectedField && dataType !== "boolean" && (
          <input
            className={styles.input}
            type={dataType === "number" ? "number" : dataType === "date" ? "date" : "text"}
            placeholder={dataType === "number" ? "0" : dataType === "date" ? "" : "Valor..."}
            value={textValue}
            onChange={(e) => setTextValue(e.target.value)}
            onKeyDown={(e) => { if (e.key === "Enter") handleAdd(); }}
          />
        )}
        {selectedField && dataType === "boolean" && (
          <div className={styles.boolRow}>
            <Toggle checked={boolValue} onChange={setBoolValue} />
            <span className={styles.boolLabel}>{boolValue ? "Sí" : "No"}</span>
          </div>
        )}
      </div>
      <div className={styles.actions}>
        <button
          type="button"
          className={styles.saveBtn}
          onClick={handleAdd}
          disabled={saving || !selectedId}
        >
          {saving ? "Guardando..." : "Guardar"}
        </button>
        <button type="button" className={styles.cancelBtn} onClick={onCancel}>
          Cancelar
        </button>
      </div>
    </div>
  );
}
